<template>
  <Category />
</template>

<script>
import Category from '@/components/Category/Category.vue';

export default {
  name: 'CategoryView',
  components: {
    Category,
  },
};
</script>
